module.exports = __webpack_public_path__ + "img/target-headhunter.e71bdcbe.svg";